<script>
import {
  layoutMethods,
  eventListMethods,
  erpUserRolesMethods
} from "@/state/helpers";
import Swal from "sweetalert2";
// import Multiselect from "vue-multiselect";
import ImageUploader from "@/components/ImageUploader";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { getModuleAccess } from '@/router/helper.js'

/**
 * Add Event component
 */
export default {
  page: {
    title: "Add Event",
  },
  data() {
    return {
      title: "Add Event",
      eventId: 0,
      eventLogo: {
        filename: null,
        type: null,
        base64: null,
      },
      event: {
        eventId: null,
        eventImageSrc: "",
        eventName: "",
        eventDescription: "",
        eventMeetingUrl: "",
        eventStartDate: null,
        eventEndDate: null,
        eventStatus: 1,
      },
      formExitChecker: {
        eventId: null,
        eventImageSrc: "",
        eventName: "",
        eventDescription: "",
        eventMeetingUrl: "",
        eventStartDate: null,
        eventEndDate: null,
        eventStatus: 1,
      },
      isEditForm : false,
      isSubmitted: false,
      formStatus: '',
      formValidation: {
          img: false,
          name: false,
          desc: false,
          startDate: false,
          endDate: false
      },
      folder: 'event-images',
      minDate: 'today',
      eventsModule: {
          access: {
            create: true,
            update: true
          }
        }
    };
  },
  components: {
    // Multiselect,
    ImageUploader,
    flatPickr,
  },
  methods: {
    ...layoutMethods,
    ...eventListMethods,
    ...erpUserRolesMethods,
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    clearLogo() {
      this.eventLogo = {
        filename: null,
        type: null,
        base64: null,
      };
    },
    checkForm() {
      this.formValidation.startDate = false;
      this.formValidation.endDate = false;
      this.formValidation.desc = false;
      this.formValidation.name = false;
      this.formValidation.img = false;
      var status = true;
      if(this.checkDate(this.event.eventStartDate) == false){
        status = false;
        this.formValidation.startDate = true;
      }
      if(this.checkDate(this.event.eventEndDate) == false){
        status = false;
        this.formValidation.endDate = true;
      }
      if(this.event.eventDescription.length == 0){
        status = false;
        this.formValidation.desc = true;
      }
      if(this.event.eventName.length == 0){
        status = false;
        this.formValidation.name = true;
      }
      if(this.eventLogo.filename == null && this.event.eventImageSrc.length == 0){
        status = false;
        this.formValidation.img = true;
      }
      console.log(">> Event details",this.event,this.formValidation,this.eventLogo);
      if(status){ 
        this.isSubmitted = true;
        if (this.isEditForm) {
          this.formStatus = "Uploading Image...";
          this.updateEvent();
          // alert("Update Form")
        } else {
          // alert("Create Form")
          this.formStatus = "Uploading Image...";
          this.createEvent();
        }
      }
    },
    checkDate(date){
      if(date == null){return false;}
      var d = new Date(date);
        // An invalid date object returns NaN for getTime() and NaN is the only
        // object not strictly equal to itself.
        return d.getTime() === d.getTime();
    },
    createEvent() {
      var eventObj = { ...this.event };
      delete eventObj.eventId;

      if (this.eventLogo.base64) {
        var eventLogo = { ...this.eventLogo };
        eventLogo.folder = this.folder;

        this.uploadLogo(eventLogo)
          .then((imageKey) => {
            console.log(">> HELLO image:", imageKey);
            eventObj.eventImageSrc = imageKey;
            console.log(JSON.stringify(eventObj));
            this.formStatus = "Creating Event...";
            this.create(eventObj);
          })
          .catch((err) => {
            console.log(">> AWTS:", err);
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.create(eventObj);
      }
    },
    create(eventObj) {
      console.log("over HERE");
      this.createEventAPI(eventObj)
        .then(() => {
          Swal.fire(
            "Create Successful!",
            `${eventObj.eventName} has been created.`,
            "success"
          );
          this.formStatus = "";
          this.isSubmitted = false;
          this.clearLogo();
          this.event  = {
            eventId: null,
            eventImageSrc: "",
            eventName: "",
            eventDescription: "",
            eventMeetingUrl: "",
            eventStartDate: null,
            eventEndDate: null,
            eventStatus: 1,
          }
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Event List",
            }
          );
        })
        .catch((e) => {
          console.log("Err::",e);
          Swal.fire(
            "Create Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${eventObj.eventName} was not created.`,
            "error"
          );
          // this.clearLogo();
          this.formStatus = "";
          this.isSubmitted = false;
        });
    },
    removeImageInS3(imageKey = ''){
      this.removeUploadLogo(imageKey)
      .then((res) => {
        console.log(">> remove res:", res);
      })
      .catch((err) => {
        console.log(">> remove err:", err);
      });
    },
    editEvent(eventId) {
      // this.logoPreview = null;
      this.getEvent(eventId).then((eventData) => {
        this.event = { ...eventData };
        this.formExitChecker = { ...eventData };
        this.isEditForm = true;
        this.minDate = this.dateEditable(this.event.eventStartDate, 'after')?this.event.eventStartDate:'today';
        // this.dateEditable(this.event.eventStartDate);
      });
    },
    updateEvent() {
      var eventObj = { ...this.event };
      eventObj.eventId = eventObj.eventId.toString();
      eventObj.eventImageSrc = eventObj.image_src;
      eventObj.eventImageSrcBefore = eventObj.image_src;

      if (this.eventLogo.base64) {
        var eventLogo = { ...this.eventLogo };
        eventLogo.folder = this.folder;

        this.uploadLogo(eventLogo)
          .then((imageKey) => {
            eventObj = {
              ...eventObj,
              eventImageSrc: imageKey,
            };

            this.update(eventObj);
          })
          .catch((err) => {
            Swal.fire("Upload Failed!", `${err}`, "error");
          });
      } else {
        this.update(eventObj);
      }
    },
    update(eventObj) {
      this.formStatus = "Updating event...";
      this.updateEventItem(eventObj)
        .then(() => {
          // this.isEditForm = false;
          Swal.fire(
            "Update Successful!",
            `${eventObj.eventName} has been updated.`,
            "success"
          );
          this.formStatus = "";
          this.isSubmitted = false;
          this.event  = {
            eventId: null,
            eventImageSrc: "",
            eventName: "",
            eventDescription: "",
            eventMeetingUrl: "",
            eventStartDate: null,
            eventEndDate: null,
            eventStatus: 1,
          }
          this.formExitChecker = this.event;
          this.clearLogo();
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Event List",
            }
          );
        })
        .catch((e) => {
          // this.isEditForm = false;
          Swal.fire(
            "Update Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${eventObj.eventName} was not updated.`,
            "error"
          );
          // this.clearLogo();
          this.formStatus = "";
          this.isSubmitted = false;
        });
    },
    leaveform(next){
        if(JSON.stringify(this.event) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    dateEditable(date, type = ''){
      var dateJson ={
        "after" :moment().isAfter(moment(date)),
        "same"  :moment().isSame(moment(date)),
        "before":moment().isBefore(moment(date))
      }
      if(type == "after" || type == "same" || type == "before"){
          console.log(">> dateEditable:",type,dateJson[type]);
          return dateJson[type];
      }else{
          alert(JSON.stringify(dateJson));
      }
    }
  },
  async mounted() {
    this.eventId = this.$route.params.id;
    this.changeTitle({
      title: (this.eventId > 0 ? "Edit" : "Add") + " Event List",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'Event List', to: { name: 'Event List'} },
        { text: "Item", to: { name: "Add Event" } }
      ],
    });
    if (this.eventId > 0) {
      this.editEvent(this.eventId);
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Utilities', 'Events')
        .then((access) => this.eventsModule.access = access);

  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
      console.log("><><><><> HEY",JSON.stringify(this.event),JSON.stringify(this.formExitChecker));
      this.leaveform(next);
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="pe-lg-2">
            <image-uploader
              class="me-4"
              v-model="eventLogo"
              :imageSrc="event.eventImageSrc"
            />
            <div
                v-if="formValidation.img"
                style="color: #f34e4e;font-size: 87.5%;text-align: center;">
                Image is required.
            </div>
          </div>
          <!-- end of img upload-->
          
          
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="width: 620px">
                <div class="row">
                  <label v-if="eventId <= 0 && !eventsModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create an Event.</label>
                  <label v-else-if="eventId > 0 && !eventsModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update an Event .</label>
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Event Name*</label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter event name"
                      :class="{
                          'is-invalid' : formValidation.name
                      }"
                      v-model="event.eventName"
                    />
                    <div
                        v-if="formValidation.name"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of event name-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Event Description*</label>
                    <b-form-textarea
                      class="form-control"
                      placeholder="Enter event description"
                      v-model="event.eventDescription"
                      :class="{
                          'is-invalid' : formValidation.desc
                      }"
                    />
                    <div
                        v-if="formValidation.desc"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of event description-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Add Meeting Link (Optional)</label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter event link"
                      v-model="event.eventMeetingUrl"
                    />
                  </div><!--end of event link-->

                  <div class="col-md-6 mb-3">
                    <label class="form-label">Start Event</label>
                    <flat-pickr
                      placeholder="Select a date"
                      v-model="event.eventStartDate"
                      :config="{ minDate: minDate, maxDate: event.eventEndDate, enableTime: true, dateFormat: 'Y-m-d H:i'}"
                      class="form-control"
                      :class="{
                          'is-invalid' : formValidation.startDate
                      }"
                      required
                    ></flat-pickr>
                    <div
                        v-if="formValidation.startDate"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label">End Event</label>
                    <flat-pickr
                      placeholder="Select a date"
                      v-model="event.eventEndDate"
                      :config="{ minDate: event.eventStartDate, enableTime: true, dateFormat: 'Y-m-d H:i'}"
                      class="form-control"
                      :class="{
                          'is-invalid' : formValidation.endDate
                      }"
                    ></flat-pickr>
                    <div
                        v-if="formValidation.endDate"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                      <input
                        class="form-check-input"
                        v-model="event.eventStatus"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <!--end of event status-->


                  <div class="col-md-6 mt-3" v-if="!isSubmitted">
                    <b-button :disabled="eventId > 0 ? !eventsModule.access.update : !eventsModule.access.create" variant="primary" class="w-sm w-100p" type="submit">{{isEditForm ? 'Update':'Save'}}</b-button>
                  </div>
                  <div class="col-md-6 mt-3" v-if="!isSubmitted">
                    <router-link :to="{ name: 'Event List', params: {} }" class="tc-white">
                      <b-button variant="light" class="w-sm w-100p" type="button" >Cancel</b-button>
                    </router-link>
                  </div>
                  <div class="col-md-6 mt-3" v-if="isSubmitted">
                    {{formStatus}}
                  </div>
                </div><!-- end of row-->
              </div><!-- end of card body -->
              <div class="col-md-6 mt-3" v-if="false">
                <b-button variant="primary" class="w-sm w-100p" type="button" @click="removeImageInS3('event-images/kVK3XJpVz.png')">test remove</b-button>
              </div>
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> 
    </ValidationObserver><!-- end of validation observer-->
  </div>
  <!-- end of row-->
</template>


<style>
.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}
</style>